import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import MailchimpSettingsHtml from './mailchimp.settings.html'

export function MailchimpStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'MailChimpSettingsCtrl',
    name       : 'app.mailchimp-settings',
    templateUrl: MailchimpSettingsHtml,
    url        : '/mailchimp_settings',
    resolve    : {
      session : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings: ( workshopAPI : ApiService ) : ng.IPromise<any> =>  workshopAPI.get('/company')
    }
  });
}